<template>
  <div class="wa-header-wrapper">
    <img-v3 :src="formItem.icon_url" alt="" />
  </div>
</template>
<script>
export default {
  props: ["formItem"],
  mounted() {},
};
</script>
<style lang="scss" scoped>
.wa-header-wrapper {
  // position: absolute;
  // left: 0;
  // top: 0;
  display: flex;
  align-items: center;
  width: 100%;
  height: 0.71rem;
  background: #424242;
  > img {
    position: relative;
    left: 0.4rem;
    width: 1.28rem;
    height: 0.4rem;
  }
}
</style>


